import { ThreadPanel } from 'components/editor/GridDndEditor/TiptapEditor/components/Comments/ThreadPanel';
import { useComments } from 'providers/CommentsContext';

export const PreviewMainGrid = ({
  children,
  hasLeftAside,
  contentId,
}: {
  children: React.ReactNode;
  hasLeftAside?: boolean;
  contentId: string;
}) => {
  const { commentsEnabled } = useComments();

  if (commentsEnabled) {
    return (
      <main className="preview__main_comments" style={{ paddingLeft: hasLeftAside ? '240px' : '0' }}>
        <div className="preview__main__grid__content_comments">{children}</div>
        <ThreadPanel contentId={contentId} />
      </main>
    );
  }

  return (
    <main className="preview__main">
      <div className="preview__main__grid__content">{children}</div>
    </main>
  );
};
